/**
 * @author Yaochao
 * @date 2021/10/9 19:44
 * @description
 */
import React from 'react'
import {Popover} from "antd";
import custService from "../../images/customerService/custService.png";
import contactCust from "../../images/customerService/contactCust.png";

class Contact extends React.Component {

    render() {
        return (
            <>
                <Popover placement="left" title={''}
                         content={<img src={contactCust} style={{width: '250px', marginRight: '-40px'}}/>}
                         trigger="hover"
                         overlayInnerStyle={{
                             marginRight: '-30px',
                             padding: '0',
                             background: 'none',
                             boxShadow: 'none'
                         }}
                >
                    <img src={custService} className={'custService'}/>
                </Popover>
            </>
        )
    }
}

export default Contact